export default "__VITE_ASSET__CAupG0RX__"